<app-common-page-breadcrumbs [navigationData]="navigationData" [pageTitle]="title">
</app-common-page-breadcrumbs>
<div class="container py-5" id="faqStuff">
  <h2 class="faq ff-semibold fs-32 text-primary"> {{'home.help.User' | cxTranslate}}</h2>
  <div>{{'home.help.refer' | cxTranslate}}</div>

  <br>
  <div *ngFor="let item of DocumentLinks" [ngClass]="{'d-none': item.url==''}" >
    <div class="row" *ngIf="item.visibilityIndicator==true">
      <div class="" *ngIf="item.type=='mobile'">
        <div class="rounded-top-left-1 rounded-bottom-left-1 ml-3 background">
          <img class="img" src="/images/mobile_help.svg" width="25px">
        </div>
      </div>
      <div class="" *ngIf="item.type=='desktop'">
        <div class=" ml-3 background rounded-top-left-1 rounded-bottom-left-1">
          <img src="/images/Vector.svg" width="39px" class="mt-4 ml-4">
        </div>
      </div>

      <div class="column">
        <div class="card width guide rounded-top-right-1 rounded-bottom-right-1  ">
          <h5 class="mt-4 ml-4 ff-semibold   text-primary"><a class="ff-semibold text-small" (click)="downloadPDF(item.url)"
              id="iconID">{{ item.name }}</a></h5>

        </div>
      </div>
    </div>
    <br>
  </div>
 